import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconWellBlueSizeS from './IconWellBlue_size_s';

const props: CreateIconArguments = {
  l: IconWellBlueSizeS,
  m: IconWellBlueSizeS,
  s: IconWellBlueSizeS,
  xs: IconWellBlueSizeS,
  name: 'IconWellBlue',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
